import axios from '../base/axios';
import API_KEY from './key';

const GET_ACTION = 'flixfrenzy/redux/GET_ACTION';

// eslint-disable-next-line default-param-last
const actionReducer = (state = [], action) => {
  switch (action.type) {
    case GET_ACTION:
      return action.payload;
    default:
      return state;
  }
};

export const getAction = () => async (dispatch) => {
  await axios.get(`discover/movie?api_key=${API_KEY}&with_genres=28`).then((res) => {
    dispatch({
      type: GET_ACTION,
      payload: res.data,
    });
  });
};

export default actionReducer;
